<template>
    <card-sections
        :title="Lang.get('employerdashboard::pages/settings/profile.title')"
        :subtitle="Lang.get('employerdashboard::pages/settings/profile.subtitle')"
        :tabName="'profile'"
    >
        <div class="row mb-4">
            <div class="col-md-12">
                <div class="d-flex justify-content-between">
                    <p>
                        {{ Lang.get('employerdashboard::shared.email') }}: <span class="font-weight-semibold">{{ email }}</span>
                    </p>
                    <a :href="route('nl.employerdashboard.settings.primary-email.edit', {
                    company_as_uuid: this.$page.props.auth.user.selected_company.uuid})" class="ml-3">
                        {{ Lang.get('employerdashboard::shared.edit') }}
                    </a>
                </div>
            </div>
            <div class="col-md-12">
                <div class="d-flex justify-content-between" v-if="recovery_email">
                    <p>
                        {{ Lang.get('employerdashboard::shared.recovery_email') }}
                        <span class="font-weight-semibold">{{ recovery_email }}</span>
                    </p>
                    <a :href="route('nl.employerdashboard.settings.recovery-mail.edit', {
                        company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                        return_url: this.route('nl.employerdashboard.settings.profile', {
                            company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                        })
                    })" class="ml-3">
                        {{ Lang.get('employerdashboard::shared.edit') }}
                    </a>
                </div>
                <div v-else>
                    <a :href="route('nl.employerdashboard.settings.recovery-mail.create', {
                        company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                        return_url: this.route('nl.employerdashboard.settings.profile', {
                            company_as_uuid: this.$page.props.auth.user.selected_company.uuid,
                        })
                    })">
                        {{ Lang.get('employerdashboard::shared.setup_recovery_email') }}
                    </a>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="form-group col-md-4">
                <text-input
                    v-model="profile.firstname"
                    :label="Lang.get('employerdashboard::shared.firstname')"
                    :placeholder="Lang.get('employerdashboard::shared.placeholder.firstname')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-md-4">
                <text-input
                    v-model="profile.middlename"
                    :label="Lang.get('employerdashboard::shared.middlename')"
                    :placeholder="Lang.get('employerdashboard::shared.placeholder.middlename')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-md-4">
                <text-input
                    v-model="profile.lastname"
                    :label="Lang.get('employerdashboard::shared.lastname')"
                    :placeholder="Lang.get('employerdashboard::shared.placeholder.lastname')"
                    :disabled="true"
                />
            </div>
            <div class="form-group col-12 col-md-4 col-lg-3 mt-4">
                <inertia-link
                    :href="route('nl.employerdashboard.settings.profile.edit', this.$page.props.auth.user.selected_company.uuid)"
                    class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4">
                    {{ Lang.get('employerdashboard::shared.edit') }}
                </inertia-link>
            </div>
        </div>

    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/settings/profile.title') },
    components: {
        CardSections,
        TextInput,
    },
    props: {
        profile: Object,
        email: String,
        recovery_email: String,
    },
    mounted() {
        const modalBackground = document.querySelector('.modal-backdrop');

        if (modalBackground) {
            modalBackground.remove();
        }
    }
}
</script>
